// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
app-root .space-recs-header {
  width: 100%;
  max-width: 695px;
  margin: 0 auto 32px;
}
app-root .space-recs-header h2 {
  font-size: 32px;
  text-align: left;
}
app-root .space-recs {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 695px;
  margin: 0 auto 32px;
}
app-root .space-recs .space-recs-card {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid #af231c;
  background: #fff;
  margin: 0 auto;
}
app-root .space-recs .space-recs-card-needs-choice {
  border-color: #f5222d;
  color: #f5222d;
  box-shadow: 0 0 0 2px rgba(232, 132, 132, 0.28);
}
app-root .space-recs .space-recs-image-carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 248px;
}
app-root .space-recs .space-recs-image-carousel img {
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
app-root .space-recs .space-recs-image-carousel .space-recs-image-carousel-nav {
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
app-root .space-recs .space-recs-image-carousel .space-recs-image-carousel-nav button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  border: none;
  outline: none;
  height: 36;
  width: 24;
  cursor: pointer;
}
app-root .space-recs .space-recs-card-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  padding: 16px;
}
app-root .space-recs .space-recs-card-content h3 {
  font-size: 16px;
  margin: 0;
  text-align: left;
}
app-root .space-recs .space-recs-card-content p {
  text-align: left;
}
app-root .space-recs .space-recs-card-content .space-recs-card-tags {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}
app-root .space-recs .space-recs-card-content .space-recs-card-tag {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #595959;
  font-weight: 500;
}
app-root .space-recs .space-recs-card-content .space-recs-card-tag-recommended {
  border-color: #af231c;
  background-color: #af231c;
  color: #fff;
}
app-root .space-recs .space-recs-card-content .space-recs-card-details {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
}
app-root .space-recs .space-recs-card-content .space-recs-card-clamp {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
app-root .space-recs .space-recs-card-content .space-recs-card-text-md {
  font-size: 14px;
}
app-root .space-recs .space-recs-card-content .space-recs-card-text-sm {
  font-size: 12px;
}
app-root .space-recs .space-recs-card-content .space-recs-icon {
  display: inline-block;
  vertical-align: text-bottom;
}
app-root .space-recs .space-recs-card-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
@media (min-width: 600px) {
  app-root .space-recs .space-recs-card-actions {
    flex-direction: row;
    gap: 24px;
  }
}
app-root .space-recs .space-recs-card-actions .hb-button {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding-left: 16px;
  padding-right: 16px;
}
app-root .space-recs .space-recs-card-actions .space-recs-card-rejected {
  background-color: #000;
  color: #fff;
}
app-root .recs-nav {
  margin: 0 -16px;
  width: 100%;
  min-width: 320px;
  position: fixed;
  left: 16px;
  bottom: 0;
  margin-bottom: 0;
  padding: 0 16px 16px;
  font-size: 1rem;
  background-color: white;
  border-top: 1px solid var(--header-border);
  z-index: 10;
}
app-root .recs-nav .recs-nav-row {
  margin: 0 auto;
  max-width: 792px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
@media (min-width: 900px) {
  app-root .recs-nav .recs-nav-row {
    width: calc(9 * (100% - 176px) / 12 + 128px);
  }
}
@media (min-width: 1151px) {
  app-root .recs-nav .recs-nav-row {
    width: calc(6 * (100% - 176px) / 12 + 80px);
  }
}
app-root .recs-nav .recs-nav-status {
  text-align: center;
  font-size: 0.875rem;
  font-weight: 500;
  color: #f5222d;
  min-height: 1.25rem;
  opacity: 0;
  will-change: transform, opacity;
  transform: translateY(-0.8rem);
  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0.05s;
}
app-root .recs-nav .recs-nav-status.show {
  opacity: 1;
  transform: translateY(0);
}
app-root .recs-nav .recs-nav-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
app-root .recs-nav .hb-button:focus-visible {
  outline: 2px solid #af231c;
  outline-offset: 2px;
}
app-root .lf-flow.loaded .recs-nav {
  margin: 0 -16px;
  left: 16px;
  width: 100%;
  min-width: 320px;
  position: fixed;
}
@media (min-width: 1151px) {
  app-root .lf-flow.loaded .recs-nav {
    width: 66%;
  }
}
app-root .lf-flow.loaded .recs-nav-row {
  margin: 0 auto;
  max-width: 792px;
}
@media (min-width: 900px) {
  app-root .lf-flow.loaded .recs-nav-row {
    width: calc(9 * (100% - 176px) / 12 + 128px);
  }
}
@media (min-width: 1151px) {
  app-root .lf-flow.loaded .recs-nav-row {
    width: calc(6 * (100% - 176px) / 12 + 80px);
  }
}
@media (min-width: 1151px) {
  app-root .lf-flow.loaded .recs-nav-row {
    width: calc(6 * (100% - 112px) / 8 + 80px);
  }
}
@media (min-width: 1350px) {
  app-root .lf-flow.loaded .recs-nav-row {
    width: calc(8 * (100% - 144px) / 10 + 112px);
  }
}
@media (min-width: 1500px) {
  app-root .lf-flow.loaded .recs-nav-row {
    width: calc(6 * (100% - 144px) / 10 + 80px);
  }
}
app-root .lf-flow .page-content.lf-recommendations-page,
app-root .lf-flow .page-content.success-page {
  padding-bottom: calc(var(--action-bar-height, calc(calc(1.5rem + 47px) + 5.5rem)) + 1.5rem);
}
@media (min-width: 640px) {
  app-root .lf-flow .page-content.lf-recommendations-page,
  app-root .lf-flow .page-content.success-page {
    padding-bottom: calc(var(--action-bar-height, calc(calc(1.5rem + 47px) + 3rem)) + 1.5rem);
  }
}
app-root .recs-unserved {
  width: 100%;
  max-width: 695px;
  margin: 0 auto;
  padding: 48px 32px;
  border: 1px solid #f5222d;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
}
app-root .recs-unserved .recs-unserved-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0;
  border-radius: 50%;
  background-color: rgba(245, 34, 45, 0.08);
  color: #f5222d;
}
app-root .recs-unserved .recs-unserved-icon svg {
  width: 28px;
  height: 28px;
}
app-root .recs-unserved .recs-unserved-copy {
  margin: 0;
  max-width: 46ch;
  font-size: 1rem;
  line-height: 1.6;
}
app-root .hb-button {
  padding: 7px 28px;
  display: inline-block;
  text-align: center;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border-radius: 4px;
  will-change: color, transform;
  outline-offset: 3px;
  transition: background-color 0.2s ease-in-out, transform 0.1s ease-in-out;
}
app-root .hb-button.primary-button {
  outline-color: black;
  border: none;
  background-color: #8c1c16;
  color: white;
}
app-root .hb-button.primary-button:active {
  transform: scale(0.95);
}
app-root .hb-button.primary-button:hover {
  background-color: #c52820;
}
app-root .hb-button.primary-button:disabled {
  background-color: var(--background-grey);
  border-color: var(--outline-grey);
  color: var(--outline-grey);
}
app-root .hb-button.secondary-button {
  color: var(--border-grey);
  padding-top: 6px;
  padding-bottom: 6px;
  outline-offset: 4px;
  border: 1px solid var(--border-grey);
  text-decoration: none;
}
app-root .hb-button.secondary-button:active {
  transform: scale(0.95);
}
app-root .hb-button.secondary-button:visited {
  color: var(--border-grey);
}
app-root .hb-button.secondary-button:hover {
  color: var(--primary);
}
app-root .hb-button.secondary-button:disabled {
  background-color: var(--background-grey);
  border-color: var(--outline-grey);
  color: var(--outline-grey);
  transform: none;
}
app-root .hb-button.button-small {
  padding: 2px 24px;
}
.recommendation-map-panel .google-map.show {
  height: 700px;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Views/Recommendations/RecommendationInput.less","webpack://./src/Views/Success/LeadFeed/LeadFeedSuccess.less","webpack://./src/Styles/GridLayout/layoutHelpers.less","webpack://./src/Styles/buttons.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;ACHA;EAEI,WAAA;EACA,gBAAA;EACA,mBAAA;ADIJ;ACRA;EAOM,eAAA;EACA,gBAAA;ADIN;ACZA;EAaI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;ADEJ;ACpBA;EAqBM,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;ADEN;AC9BA;EAgCM,qBAAA;EACA,cAAA;EACA,+CAAA;ADCN;ACnCA;EAsCM,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;ADAN;AC3CA;EA8CQ,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;ADAR;ACjDA;EAqDQ,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;ADDR;ACxDA;EA4DU,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;ADDV;ACpEA;EA8EM,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;ADPN;AC5EA;EAsFQ,eAAA;EACA,SAAA;EACA,gBAAA;ADPR;ACjFA;EA4FQ,gBAAA;ADRR;ACpFA;EAgGQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;ADTR;AC3FA;EAwGQ,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;ADVR;AClGA;EAgHQ,qBAAA;EACA,yBAAA;EACA,WAAA;ADXR;ACvGA;EAsHQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;ADZR;AC7GA;EA6HQ,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;ADbR;ACnHA;EAoIQ,eAAA;ADdR;ACtHA;EAwIQ,eAAA;ADfR;ACzHA;EA6IQ,qBAAA;EACA,2BAAA;ADjBR;AC7HA;EAmJM,aAAA;EACA,sBAAA;EACA,QAAA;ADnBN;ACqBM;EAAA;IACE,mBAAA;IACA,SAAA;EDlBN;AACF;ACxIA;EA6JQ,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ADlBR;AC/IA;EAqKQ,sBAAA;EACA,WAAA;ADnBR;ACnJA;EF6BE,eAAA;EAEA,WAAA;EACA,gBAAA;EACA,eAAA;EE6IE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,0CAAA;EACA,WAAA;ADpBJ;ACjKA;ECeE,cAAA;EACA,gBAAA;ED4KI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;ADtBN;AEvJE;EAAA;IAXA,4CAAA;EFsKA;AACF;AErJE;EAAA;IAlBA,2CAAA;EF2KA;AACF;ACnLA;EAqMM,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,+BAAA;EACA,8BAAA;EACA,sHAAA;ADfN;ACkBM;EACE,UAAA;EACA,wBAAA;ADhBR;ACqBM;EACE,YAAA;EACA,mBAAA;ADnBR;ACtMA;EA8NM,0BAAA;EACA,mBAAA;ADrBN;AC1MA;EF6BE,eAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;ACgLF;AD5IE;EAAA;IACE,UAAA;EC+IF;AACF;ACtNA;ECeE,cAAA;EACA,gBAAA;AF0MF;AExME;EAAA;IAXA,4CAAA;EFuNA;AACF;AEtME;EAAA;IAlBA,2CAAA;EF4NA;AACF;ADrLE;EAAA;IGxCA,0CAAA;EFiOA;AACF;ADvLE;EAAA;IG3CA,4CAAA;EFsOA;AACF;ADzLE;EAAA;IG9CA,2CAAA;EF2OA;AACF;ACDI;;EAIE,2FAAA;ADCN;ACCM;EAAA;;IACE,yFAAA;EDGN;AACF;AC7PA;EAgQI,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;ADAJ;AC1QA;EA6QM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;ADAN;ACrRA;EAwRQ,WAAA;EACA,YAAA;ADAR;ACzRA;EA8RM,SAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;ADFN;AGpSA;EAEI,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,yEAAA;AHqSJ;AGnSI;EACE,oBAAA;EACA,YAAA;EAGA,yBAAA;EACA,YAAA;AHmSN;AGlSM;EACE,sBAAA;AHoSR;AGjSM;EACE,yBAAA;AHmSR;AGhSM;EACE,wCAAA;EACA,iCAAA;EACA,0BAAA;AHkSR;AG/RI;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA;AHiSN;AG/RM;EACE,sBAAA;AHiSR;AG9RM;EACE,yBAAA;AHgSR;AG7RM;EACE,qBAAA;AH+RR;AG5RM;EACE,wCAAA;EACA,iCAAA;EACA,0BAAA;EACA,eAAA;AH8RR;AG1RI;EACE,iBAAA;AH4RN;AAxVA;EAEI,aAAA;AAyVJ","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../Success/LeadFeed/LeadFeedSuccess.less';\n@import '../../Styles/buttons.less';\n\n.recommendation-map-panel {\n  .google-map.show {\n    height: 700px;\n  }\n}\n","@import '../../../Styles/utilities.less';\n@import '../../../Styles/colours.less';\n\n@xsmall: ~'(max-width: 374px)';\n\napp-root {\n  .space-recs-header {\n    width: 100%;\n    max-width: 695px;\n    margin: 0 auto 32px;\n\n    h2 {\n      font-size: 32px;\n      text-align: left;\n    }\n  }\n\n  .space-recs {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    max-width: 695px;\n    margin: 0 auto 32px;\n\n    .space-recs-card {\n      display: flex;\n      flex-direction: row;\n      width: 100%;\n      gap: 16px;\n      border-radius: 8px;\n      border: 1px solid @primary;\n      background: #fff;\n      margin: 0 auto;\n    }\n\n    .space-recs-card-needs-choice {\n      border-color: @error-red;\n      color: @error-red;\n      box-shadow: 0 0 0 2px rgb(232 132 132 / 28%);\n    }\n\n    .space-recs-image-carousel {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      width: 248px;\n\n      img {\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        object-fit: cover;\n      }\n\n      .space-recs-image-carousel-nav {\n        z-index: 10;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        width: 100%;\n\n        button {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n          background-color: rgba(255, 255, 255, 0.7);\n          border: none;\n          outline: none;\n          height: 36;\n          width: 24;\n          cursor: pointer;\n        }\n      }\n\n      // space-recs-image-carousel-nav-prev\n      // space-recs-image-carousel-nav-next\n    }\n\n    .space-recs-card-content {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 16px;\n      width: 100%;\n      padding: 16px;\n\n      h3 {\n        font-size: 16px;\n        margin: 0;\n        text-align: left;\n      }\n\n      p {\n        text-align: left;\n      }\n\n      .space-recs-card-tags {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        flex-wrap: wrap;\n        gap: 8px;\n      }\n\n      .space-recs-card-tag {\n        font-size: 12px;\n        padding: 2px 8px;\n        border-radius: 12px;\n        border: 1px solid @border-grey;\n        font-weight: 500;\n      }\n\n      .space-recs-card-tag-recommended {\n        border-color: @primary;\n        background-color: @primary;\n        color: #fff;\n      }\n\n      .space-recs-card-details {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        gap: 16px;\n      }\n\n      .space-recs-card-clamp {\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n      }\n\n      .space-recs-card-text-md {\n        font-size: 14px;\n      }\n\n      .space-recs-card-text-sm {\n        font-size: 12px;\n      }\n\n      // Tailwind's preflight makes svg `display: block`, which drops the icon above its label.\n      .space-recs-icon {\n        display: inline-block;\n        vertical-align: text-bottom;\n      }\n    }\n\n    .space-recs-card-actions {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      @media @portraitTabletUp {\n        flex-direction: row;\n        gap: 24px;\n      }\n\n      .hb-button {\n        display: inline-flex;\n        align-items: center;\n        gap: 0.25rem;\n        padding-left: 16px;\n        padding-right: 16px;\n      }\n\n      .space-recs-card-rejected {\n        background-color: #000;\n        color: #fff;\n      }\n    }\n  }\n\n  .recs-nav {\n    .fixed-full-width-content();\n\n    left: @body-gutter-width;\n    bottom: 0;\n    margin-bottom: 0;\n    padding: 0 @body-gutter-width @body-gutter-width;\n    font-size: 1rem;\n    background-color: white;\n    border-top: 1px solid var(--header-border);\n    z-index: 10;\n\n    // Same centred column the standard form nav gives .button-wrapper, holding\n    // nothing but the action.\n    .recs-nav-row {\n      .wide-content();\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 12px;\n    }\n\n    // Same treatment as .error-message in ValidationMessage.less - the line is\n    // always reserved so revealing the message cannot shift the action.\n    .recs-nav-status {\n      text-align: center;\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: @error-red;\n      min-height: 1.25rem;\n      opacity: 0;\n      will-change: transform, opacity;\n      transform: translateY(-0.8rem);\n      transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1),\n        opacity 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0.05s;\n\n      &.show {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n\n    .recs-nav-submit {\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n\n    .hb-button:focus-visible {\n      outline: 2px solid @primary;\n      outline-offset: 2px;\n    }\n  }\n\n  // The LF marketing panel takes a third of the viewport - same treatment as Nav.less.\n  .lf-flow.loaded {\n    .recs-nav {\n      .fixed-two-third-width-content();\n    }\n\n    // Matches the .button-wrapper override in Nav.less.\n    .recs-nav-row {\n      .wide-leadfeed-content();\n    }\n  }\n\n  // Nested to out-specify `.lf-flow .page-content` in Page.less, which reserves less than the\n  // shortlist row this bar now carries. 640px is where the row folds onto the button's line.\n  .lf-flow .page-content {\n    &.lf-recommendations-page,\n    &.success-page {\n      // ActionBar measures itself into --action-bar-height, so expanding the shortlist reserves\n      // its own room rather than covering the cards. The fallbacks match the collapsed bar.\n      padding-bottom: calc(var(--action-bar-height, calc(@nav-height + 5.5rem)) + 1.5rem);\n\n      @media (min-width: 640px) {\n        padding-bottom: calc(var(--action-bar-height, calc(@nav-height + 3rem)) + 1.5rem);\n      }\n    }\n  }\n\n  // Shown in place of the picker where we do not cover the area at all.\n  .recs-unserved {\n    width: 100%;\n    max-width: 695px;\n    margin: 0 auto;\n    padding: 48px 32px;\n    border: 1px solid @error-red;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 24px;\n    text-align: center;\n\n    .recs-unserved-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 64px;\n      height: 64px;\n      margin: 0;\n      border-radius: 50%;\n      background-color: fade(@error-red, 8%);\n      color: @error-red;\n\n      svg {\n        width: 28px;\n        height: 28px;\n      }\n    }\n\n    .recs-unserved-copy {\n      margin: 0;\n      max-width: 46ch;\n      font-size: 1rem;\n      line-height: 1.6;\n    }\n  }\n}\n","@import '../mediaQueries.less';\n\n// These helpers are designed to replicate Product's 12-column design system.\n\n@columnGap: 16px;\n\n.calc-column-width(@columnCount, @totalColumns: 12) {\n  @combinedLayoutGaps: (@totalColumns - 1) * @columnGap;\n  @combinedElementGaps: (@columnCount - 1) * @columnGap;\n  // Delay computation until wrapped by CSS calc\n  @singleColumnWidth: ~'(100% - @{combinedLayoutGaps}) / @{totalColumns}';\n\n  width: calc(@columnCount * @singleColumnWidth + @combinedElementGaps);\n}\n\n// Centered content contained by a 'full width' parent (in LF layout, this is actually 2/3 screen)\n//\n// @columns - the width of the content in terms of number of grid columns at the largest screen size\n.main-content-width-rules(@columns) {\n  // For small screens, the content spans all of the available columns\n  margin: 0 auto;\n  max-width: 792px;\n\n  @media @landscapeTabletUp {\n    // For medium screens, the allocated columns are 50% higher.\n    // So a container spanning 6 columns on desktop spans 9 on tablet.\n    @responsiveColumns: round(@columns * 1.5);\n    .calc-column-width(@responsiveColumns);\n  }\n\n  @media @desktopUp {\n    .calc-column-width(@columns);\n  }\n}\n\n// Guard clause for case where @mediumDesktopParentColumns param is defined; see below documentaiton\n.nested-input-width-rules(@parentColumns, @mediumDesktopParentColumns: 0)\n  when\n  (\n    @mediumDesktopParentColumns > 0\n  ) {\n  @combinedParentGaps: (@mediumDesktopParentColumns - 1) * @columnGap;\n  // Delay computation until wrapped by CSS calc\n  @singleColumnWidth: ~'(100% - @{combinedParentGaps}) / @{mediumDesktopParentColumns}';\n  @media @mediumDesktopUp {\n    width: calc(100% - 2 * @singleColumnWidth);\n  }\n}\n\n// Centered content that is a child of a 'main-width' container as declared above.\n//\n// @parentColumns - the number of columns allocated to the container\n// @mediumDesktopPatentColumns - optional, the number of columns allocated to the container at\n//   medium-desktop breakpoints and up\n.nested-input-width-rules(@parentColumns, @mediumDesktopParentColumns: 0) {\n  // full width on small screens\n  width: 100%;\n  margin: 0 auto;\n\n  // drop 2 'columns' from the main-content parent width on larger screens\n\n  @responsiveColumns: @parentColumns;\n  @combinedParentGaps: (@responsiveColumns - 1) * @columnGap;\n  // Delay computation until wrapped by CSS calc\n  @singleColumnWidth: ~'(100% - @{combinedParentGaps}) / @{responsiveColumns}';\n\n  @media @landscapeTabletUp {\n    // see @responsiveColumns note above\n    @responsiveColumns: round(@parentColumns * 1.5);\n    width: calc(100% - (2 * @singleColumnWidth));\n  }\n\n  @media @desktopUp {\n    width: calc(100% - (2 * @singleColumnWidth));\n  }\n}\n","app-root {\n  .hb-button {\n    padding: 7px 28px;\n    display: inline-block;\n    text-align: center;\n    font-weight: 600;\n    text-decoration: none;\n    cursor: pointer;\n    border-radius: 4px;\n    will-change: color, transform;\n    outline-offset: 3px;\n    transition: background-color 0.2s ease-in-out, transform 0.1s ease-in-out;\n\n    &.primary-button {\n      outline-color: black;\n      border: none;\n      // background-color: var(--primary);\n      //Accessibility color contrast\n      background-color: #8c1c16;\n      color: white;\n      &:active {\n        transform: scale(0.95);\n      }\n\n      &:hover {\n        background-color: #c52820;\n      }\n\n      &:disabled {\n        background-color: var(--background-grey);\n        border-color: var(--outline-grey);\n        color: var(--outline-grey);\n      }\n    }\n    &.secondary-button {\n      color: var(--border-grey);\n      padding-top: 6px;\n      padding-bottom: 6px;\n      outline-offset: 4px;\n      border: 1px solid var(--border-grey);\n      text-decoration: none;\n\n      &:active {\n        transform: scale(0.95);\n      }\n\n      &:visited {\n        color: var(--border-grey);\n      }\n\n      &:hover {\n        color: var(--primary);\n      }\n\n      &:disabled {\n        background-color: var(--background-grey);\n        border-color: var(--outline-grey);\n        color: var(--outline-grey);\n        transform: none;\n      }\n    }\n\n    &.button-small {\n      padding: 2px 24px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
